import { createSelector } from '@ngrx/store';
import { AppState } from 'src/store';
import { CompanyEntity } from './company.model';

const selectAllCompanies = (state: AppState) => state.companies.entities;

export function selectCompanyById(id: string) {
  return createSelector(
    selectAllCompanies,
    (companies) => companies[id] as CompanyEntity | undefined,
  );
}
